/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type USER_STATUS = "ACTIVE" | "BANNED" | "PREMOD" | "SUSPENDED" | "WARNED" | "%future added value";
export type StreamContainer_viewer = {
    readonly status: {
        readonly current: ReadonlyArray<USER_STATUS>;
    };
    readonly " $fragmentRefs": FragmentRefs<"CreateCommentMutation_viewer" | "CreateCommentReplyMutation_viewer" | "ModerateStreamContainer_viewer" | "PostCommentFormContainer_viewer" | "StreamDeletionRequestCalloutContainer_viewer" | "SuspendedInfoContainer_viewer" | "UserBoxContainer_viewer" | "WarningContainer_viewer">;
    readonly " $refType": "StreamContainer_viewer";
};
export type StreamContainer_viewer$data = StreamContainer_viewer;
export type StreamContainer_viewer$key = {
    readonly " $data"?: StreamContainer_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"StreamContainer_viewer">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "StreamContainer_viewer",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "UserStatus",
            "kind": "LinkedField",
            "name": "status",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "current",
                    "storageKey": null
                }
            ],
            "storageKey": null
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CreateCommentMutation_viewer"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CreateCommentReplyMutation_viewer"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ModerateStreamContainer_viewer"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PostCommentFormContainer_viewer"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "StreamDeletionRequestCalloutContainer_viewer"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SuspendedInfoContainer_viewer"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "UserBoxContainer_viewer"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "WarningContainer_viewer"
        }
    ],
    "type": "User",
    "abstractKey": null
} as any);
(node as any).hash = '01b7088e5d62f367ff685cf07f4a560b';
export default node;
